import React from 'react';
// import { makeStyles } from '@material-ui/core/styles';
// import { Grid } from '@material-ui/core';
import PerformanceTabs from './Tabs';

// const useStyles = makeStyles((theme) => ({
//     root: {}
// }));

function Performance() {
    // const classes = useStyles();

    return <PerformanceTabs />;
}

export default React.memo(Performance);
